import styled from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Image } from '@components/web/src/foundations/Image/Image';
import { SCREEN_SIZE } from '@components/web/src/styles';

export const PromotionBadgesContainer = styled(Flexbox)`
  width: 100%;
  gap: 10px;
  cursor: pointer;
`;

export const PromotionIconWrapper = styled.div`
  height: fit-content;
`;

export const DefaultPromotionIcon = styled(Flexbox)<{ $color: string }>`
  width: 32px;
  height: 20px;
  border-radius: 4px;
  text-align: center;
  background: ${({ $color }) => $color && `${$color}`};

  span {
    line-height: normal;
    font-size: 4px;
  }

  @container rootContainer (min-width: ${SCREEN_SIZE.TABLET_WIDTH}) {
    width: 70px;
    height: 42px;

    span {
      font-size: 8px;
    }
  }
`;

export const DefaultPromotionBadge = styled(Image)`
  width: 32px;
  height: 20px;

  @container rootContainer (min-width: ${SCREEN_SIZE.TABLET_WIDTH}) {
    width: 70px;
    height: 42px;
  }
`;

export const Badge = styled(Image)`
  width: 32px;
  height: 20px;
  border-radius: 4px;

  @container rootContainer (min-width: ${SCREEN_SIZE.TABLET_WIDTH}) {
    width: 70px;
    height: 42px;
  }
`;
